
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnDestroy, OnInit, Input, ViewChild } from '@angular/core';
import { EntityService, ModalService, ToastService } from '../../blocks';
import { HrJobDegrees, HrVacationRequest } from '../personnel-stp.interfaces';
import { HrParms, SharedDateService, UserSessionService } from '../../shared';
import { FormBuilder } from '@angular/forms';
import { HrVacationRequestHelper } from '../personnel-stp.helper';
import { Location } from '@angular/common';
import { takeUntil } from 'rxjs/operators' ;  import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { RequestsListService } from './requests-list.service';
import { VacationRequestPopUpComponent } from '../vacation-request/vacation-request-popup/vacation-request-popup.component';

@Component({
  selector: 'app-requests-list',
  templateUrl: './requests-list.component.html'
})
export class RequestsListComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  Data = [];
  private helper:any;
  searchObj = <HrParms>{};
  @Input() requestType: number;
  assept : boolean = false;
  reqSerial:number;
  constructor(
    public translate: TranslateService,
    private _userSessionService: UserSessionService,
    private _RequestsListService: RequestsListService,
    private _entityService: EntityService,
    private _modalService: ModalService,
    private _router: Router,
    private _sharedDateService: SharedDateService,
    private _route: ActivatedRoute,
    private _location: Location,
    private _toastService: ToastService) {
  }
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  cancel(showToast = true) {
    this._goBack();
  }
  _goBack(): void {
    this._location.back();
  }
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  onSearchClick(_parms: any) {
    this.searchObj = _parms;
    if (this.searchObj !== null) {
       this.searchObj.ngbFromDate = _parms.ngbFromDate;
       this.searchObj.ngbToDate = _parms.ngbToDate;
       this.searchObj.section = _parms.mangCode;
       this.searchObj.empCode = _parms.empCode;
       this.searchObj.jobDegreeCode = _parms.depCode;
       this.searchObj.jobType = _parms.JopId;
       this.searchObj.offset = 0;
       this.searchObj.pageSize = 10;
       this.getListData();
    }
  }
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  getListData() {
    if (this.searchObj) {
      this.searchObj.reqType = this.requestType;
      this.searchObj.reqSerial = this.reqSerial;
      this.Data = [];
      this._RequestsListService.getRequestListData(this.searchObj)
        .subscribe(
        requests => {
            this.Data = requests.data;
        },
        error => console.log(error),
        () => { });
    }
  }
  dynamicComponent: any;
 @ViewChild('popup') content: any;

  ///dynamicComponent////////////////////////////////////////////////////////////////////////////////////////////////
  onRowIconClick(actionCode: number, vac) {
    if (actionCode == 402) {
      this._userSessionService.setSessionKey('vacData',vac);
      this._userSessionService.setSessionKey('DashOrMasterVac', 2);
      this._router.navigate([vac.serial], { relativeTo: this._route });
    }
    if (actionCode == 1013) {
      this._userSessionService.setSessionKey("PrintVacationRequest", vac);
      {
        this.dynamicComponent = VacationRequestPopUpComponent;
        this.content.openModal("VacationRequestPopUpComponent", "itemMaster", vac);
      }
    }

  }
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  ngOnInit() {
    this.getListData();
    this._userSessionService.subscribeToKey$('vacationRequestserial').pipe(
     takeUntil(this.ngUnsubscribe))
     .subscribe((keys: any) => {
       if (keys.name == 'vacationRequestserial' && keys.value) {
         this.reqSerial = keys.value;
         this.requestType = 1;
        this.getListData();
       }
     });

  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  onAsseptChange(row)
  {
    if(row)
    {
        this.searchObj.reqType = this.requestType;
        this.searchObj.empCode = row['empId'];
        this.searchObj.reqSerial = row['serial'];
        this.searchObj.accept = row['accept'];
        this.searchObj.reject = row['reject'];
        this.searchObj.statusCode = 100;
        this._RequestsListService.UpdateAlert(this.searchObj).pipe(
          takeUntil(this.ngUnsubscribe))
          .subscribe(
          requests => {
            null
          },
          error => console.log(error),
          () => { this.getListData(); });
    }
  }
  
}
